import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  Row,
  Input,
  Label,
  Col,
  Button,
  Table,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import Baja from "../Baja";
function WhatsApp() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_TELEFONOS_WHATSAPP = process.env.REACT_APP_URL_TELEFONOS_WHATSAPP;
  // const URL_LINKS_WHATSAPP = process.env.REACT_APP_URL_LINKS_WHATSAPP;
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("Esperando Estado...");
  const [telefonos, setTelefonos] = useState([]);
  // const [links, setLinks] = useState([]);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [idEdit, setIdEdit] = useState("");
  const [nameEdit, setNameEdit] = useState("");
  const [telefonoEdit, setTelefonoEdit] = useState();
  const [tipoEdit, setTipoEdit] = useState("");

  const [modalAgregar, setModalAgregar] = useState(false);
  const toggleAgregar = () => setModalAgregar(!modalAgregar);

  const [nameAgregar, setNameAgregar] = useState("");
  const [telefonoAgregar, setTelefonoAgregar] = useState();
  const [tipoAgregar, setTipoAgregar] = useState("Admin");

  // const [modalAgregarLinks, setModalAgregarLinks] = useState(false);
  // const toggleAgregarLinks = () => setModalAgregarLinks(!modalAgregarLinks);
  // const [modalEditLinks, setModalEditLinks] = useState(false);
  // const toggleEditLinks = () => setModalEditLinks(!modalEditLinks);
  // const [idEditLinks, setIdEditLinks] = useState("");
  // const [nameEditLinks, setNameEditLinks] = useState("");
  // const [linkEdit, setLinkEdit] = useState("");
  // const [nameAgregarLinks, setNameAgregarLinks] = useState("");
  // const [linkAgregar, setLinkAgregar] = useState();


  // Carga inicial de teléfonos registrados
  useEffect(() => {
    axios
      .get(`${URL_TELEFONOS_WHATSAPP}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => setTelefonos(response.data))
      .catch((err) => console.log(err));
  }, [URL_TELEFONOS_WHATSAPP]);

  // Estado de conexión: consulta inicial + sondeo cada 10s (con limpieza)
  useEffect(() => {
    const fetchStatus = () => {
      axios
        .get(`${URL_WHATSAPP}Status`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => setStatus(response.data.state))
        .catch((err) => console.log(err));
    };
    fetchStatus();
    const id = setInterval(fetchStatus, 10000);
    return () => clearInterval(id);
  }, [URL_WHATSAPP]);

  const sendMessage = async () => {
    try {
      await axios
        .post(
          `${URL_WHATSAPP}SendMsg`,
          {
            number: number,
            message: message,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          if (response.data.message == "Enviado") {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Tu mensaje ha sido enviado",
              showConfirmButton: false,
              timer: 2000,
            });
            setNumber("");
            setMessage("");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
    }
  };

  function editTelefono(event) {
    event.preventDefault();
    axios
      .patch(
        `${process.env.REACT_APP_URL_TELEFONOS_WHATSAPP}/${idEdit}`,
        {
          name: nameEdit,
          telefono: telefonoEdit,
          tipo: tipoEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Telefono Whatsapp",
            detalle: nameEdit + " / " + telefonoEdit + " / " + tipoEdit,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function crearTelefono(event) {
    event.preventDefault();
    axios
      .post(
        `${process.env.REACT_APP_URL_TELEFONOS_WHATSAPP}`,
        {
          name: nameAgregar,
          telefono: telefonoAgregar,
          tipo: tipoAgregar,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Agregar Telefono Whatsapp",
            detalle:
              nameAgregar + " / " + telefonoAgregar + " / " + tipoAgregar,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data.message}`,
        });
        console.log("hola", error.response);
      });
  }

  // function editLink(event) {
  //   event.preventDefault();
  //   axios
  //     .patch(
  //       `${process.env.REACT_APP_URL_LINKS_WHATSAPP}/${idEditLinks}`,
  //       {
  //         name: nameEditLinks,
  //         link: linkEdit,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {
  //       axios.post(
  //         URL_LOGS,
  //         {
  //           tipo: "Editar Link Whatsapp",
  //           detalle: nameEditLinks + " / " + linkEdit ,
  //           user: user.id,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //           },
  //         }
  //       );
  //       toggleEditLinks();
  //       Swal.fire("Good job!", "Actualizado con exito", "success");
  //       window.location.reload();
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //         footer: `${error.response.data}`,
  //       });
  //       console.log(error);
  //     });
  // }

  // function crearLink(event) {
  //   event.preventDefault();
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_URL_LINKS_WHATSAPP}`,
  //       {
  //         name: nameAgregarLinks,
  //         link: linkAgregar,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {
  //       axios.post(
  //         URL_LOGS,
  //         {
  //           tipo: "Agregar Link Whatsapp",
  //           detalle:
  //             nameAgregarLinks + " / " + linkAgregar,
  //           user: user.id,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //           },
  //         }
  //       );
  //       toggleEditLinks();
  //       Swal.fire("Good job!", "Actualizado con exito", "success");
  //       window.location.reload();
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //         footer: `${error.response.data.message}`,
  //       });
  //       console.log("hola", error.response);
  //     });
  // }

  // ---- Estilos de la vista (look profesional) ----
  const pageWrap = { maxWidth: 1140, marginTop: 8 };
  const cardStyle = {
    border: "none",
    borderRadius: 16,
    boxShadow: "0 6px 24px rgba(18,57,91,.08)",
    height: "100%",
  };
  const sectionTitle = { fontWeight: 700, color: "#12395B", fontSize: 17, marginBottom: 2 };
  const labelStyle = { fontSize: 13, fontWeight: 600, color: "#566573", marginBottom: 4 };
  const inputStyle = { borderRadius: 10, border: "1px solid #dfe4ea", fontSize: 14 };
  const sendBtnStyle = {
    background: "linear-gradient(135deg,#25D366,#128C7E)",
    border: "none",
    borderRadius: 10,
    fontWeight: 600,
    padding: "10px 0",
    boxShadow: "0 4px 14px rgba(18,140,126,.3)",
  };
  const addBtnStyle = { background: "#12395B", border: "none", borderRadius: 8, fontWeight: 600 };
  const infoBox = {
    background: "#eef4fb",
    color: "#3a5a78",
    borderRadius: 10,
    padding: "12px 14px",
    fontSize: 12.5,
    lineHeight: 1.55,
  };
  const tipoBadge = {
    background: "#eef1f4",
    color: "#566573",
    padding: "3px 12px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
  };
  const avatarStyle = {
    display: "inline-flex",
    width: 32,
    height: 32,
    borderRadius: "50%",
    background: "#dff5e8",
    color: "#1b8a4b",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 13,
    marginRight: 10,
    verticalAlign: "middle",
  };
  const thStyle = {
    color: "#9aa4b0",
    fontSize: 11.5,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    borderBottom: "1px solid #eef1f4",
    fontWeight: 700,
  };
  const connected = status === 2 || status === "2";

  return (
    <>
      <Header />
      <br />
      {user.usuarios_permisos ? (
        <div className="container" style={pageWrap}>
          <div className="row">
            <div className="col-12 px-2 px-md-3">
              {/* Encabezado */}
              <div
                className="d-flex align-items-center justify-content-between flex-wrap mb-4"
                style={{ gap: 12 }}
              >
                <div className="d-flex align-items-center" style={{ gap: 14 }}>
                  <div
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: 14,
                      background: "#25D366",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 14px rgba(37,211,102,.35)",
                    }}
                  >
                    <i className="fab fa-whatsapp" style={{ color: "#fff", fontSize: 30 }} />
                  </div>
                  <div>
                    <h3 className="mb-0" style={{ fontWeight: 700, color: "#12395B" }}>
                      WhatsApp Business
                    </h3>
                    <span style={{ color: "#7b8794", fontSize: 13 }}>
                      Integración con WhatsApp Business API
                    </span>
                  </div>
                </div>

                {connected ? (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#e7f9ef",
                      color: "#1b8a4b",
                      padding: "8px 18px",
                      borderRadius: 999,
                      fontWeight: 600,
                      fontSize: 14,
                    }}
                  >
                    <span
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: "#25D366",
                        boxShadow: "0 0 0 4px rgba(37,211,102,.25)",
                      }}
                    />
                    Conectado
                  </span>
                ) : (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#fdecec",
                      color: "#c0392b",
                      padding: "8px 18px",
                      borderRadius: 999,
                      fontWeight: 600,
                      fontSize: 14,
                    }}
                  >
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#e74c3c" }} />
                    Sin conexión
                  </span>
                )}
              </div>

              <Row>
                {/* Columna izquierda: enviar mensaje de prueba */}
                <Col lg={5} className="mb-4">
                  <Card style={cardStyle}>
                    <CardBody className="p-4">
                      <h5 style={sectionTitle}>
                        <i className="far fa-paper-plane mr-2" style={{ color: "#25D366" }} />
                        Enviar mensaje de prueba
                      </h5>
                      <p style={{ color: "#8a94a0", fontSize: 13, marginBottom: 18 }}>
                        Envía un mensaje directo para verificar la conexión.
                      </p>

                      <Label style={labelStyle}>Número de teléfono</Label>
                      <Input
                        type="number"
                        placeholder="Ej. 5512345678"
                        value={number}
                        style={inputStyle}
                        onChange={(e) => setNumber(e.target.value)}
                      />

                      <Label style={labelStyle} className="mt-3">
                        Mensaje
                      </Label>
                      <Input
                        type="textarea"
                        rows={3}
                        placeholder="Escribe tu mensaje..."
                        value={message}
                        style={inputStyle}
                        onChange={(e) => setMessage(e.target.value)}
                      />

                      <Button
                        block
                        className="mt-3"
                        style={sendBtnStyle}
                        disabled={!number || !message}
                        onClick={sendMessage}
                      >
                        <i className="far fa-paper-plane mr-2" />
                        Enviar mensaje
                      </Button>

                      <div style={infoBox} className="mt-4">
                        <i className="fas fa-info-circle mr-2" style={{ color: "#3a7bd5" }} />
                        El mensaje de prueba (texto libre) solo llega si esa persona te escribió
                        en las últimas 24 h. Para iniciar conversación se usa una plantilla.
                      </div>
                    </CardBody>
                  </Card>
                </Col>

      {/* <Col>
            <h4>Links</h4>
            <Button
            size="sm"
            color="danger"
            onClick={toggleAgregarLinks}
            >
                Agregar
            </Button>
                <Table
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Nombre</th>
                          <th className="tituloTabla">Link</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {links
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.name}</td>
                                  <td>{a.link}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => {
                                        setIdEditLinks(a._id);
                                        setNameEditLinks(a.name)
                                        setLinkEdit(a.link)
                                        toggleEditLinks();
                                      }}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_LINKS_WHATSAPP
                                      }
                                    />
                              
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                </Col> */}

                {/* Columna derecha: teléfonos registrados */}
                <Col lg={7} className="mb-4">
                  <Card style={cardStyle}>
                    <CardBody className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 style={sectionTitle} className="mb-0">
                          <i className="fas fa-address-book mr-2" style={{ color: "#12395B" }} />
                          Teléfonos registrados
                        </h5>
                        <Button size="sm" style={addBtnStyle} onClick={toggleAgregar}>
                          <i className="fas fa-plus mr-1" />
                          Agregar
                        </Button>
                      </div>

                      <Table hover borderless className="mb-0" style={{ fontSize: 14 }}>
                        <thead>
                          <tr>
                            <th style={thStyle}>Nombre</th>
                            <th style={thStyle}>Teléfono</th>
                            <th style={thStyle}>Tipo</th>
                            <th style={{ ...thStyle, textAlign: "right" }}>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {telefonos.length === 0 ? (
                            <tr>
                              <td
                                colSpan={4}
                                className="text-center"
                                style={{ color: "#9aa4b0", padding: "28px 0" }}
                              >
                                <i className="fas fa-inbox mr-2" />
                                Sin teléfonos registrados
                              </td>
                            </tr>
                          ) : (
                            telefonos
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((a) => (
                                <tr key={a._id} style={{ borderTop: "1px solid #f0f2f5" }}>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontWeight: 600,
                                      color: "#2c3e50",
                                    }}
                                  >
                                    <span style={avatarStyle}>
                                      {(a.name || "?").charAt(0).toUpperCase()}
                                    </span>
                                    {a.name}
                                  </td>
                                  <td style={{ verticalAlign: "middle", color: "#566573" }}>
                                    {a.telefono}
                                  </td>
                                  <td style={{ verticalAlign: "middle" }}>
                                    <span style={tipoBadge}>{a.tipo}</span>
                                  </td>
                                  <td className="text-right" style={{ verticalAlign: "middle" }}>
                                    <Button
                                      color="info"
                                      size="sm"
                                      className="mr-1"
                                      style={{ borderRadius: 8 }}
                                      onClick={(e) => {
                                        setIdEdit(a._id);
                                        setNameEdit(a.name);
                                        setTelefonoEdit(a.telefono);
                                        setTipoEdit(a.tipo);
                                        toggleEdit();
                                      }}
                                    >
                                      <i className="far fa-edit" />
                                    </Button>
                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={process.env.REACT_APP_URL_TELEFONOS_WHATSAPP}
                                    />
                                  </td>
                                </tr>
                              ))
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
                <ModalHeader toggle={toggleEdit}>Editar Telefono</ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Nombre</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={nameEdit}
                    required
                    onChange={(e) => {
                      setNameEdit(e.target.value);
                    }}
                  />
                  <Label className="mr-sm-2">Telefono</Label>
                  <Input
                    className="col-sm-12"
                    type="number"
                    value={telefonoEdit}
                    required
                    onChange={(e) => {
                      setTelefonoEdit(e.target.value);
                    }}
                  />
                  <Label className="mr-sm-2">Tipo</Label>
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={tipoEdit}
                    required
                    onChange={(e) => {
                      setTipoEdit(e.target.value);
                    }}
                  >
                    <option value="Admin">Admin</option>
                  </Input>
                </ModalBody>
                <ModalFooter>
                  <Button color="success" onClick={editTelefono}>
                    Guardar
                  </Button>
                </ModalFooter>
              </Modal>

              <Modal size="sm" isOpen={modalAgregar} toggle={toggleAgregar}>
                <ModalHeader toggle={toggleAgregar}>
                  Agregar Telefono
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Nombre</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={nameAgregar}
                    required
                    onChange={(e) => {
                      setNameAgregar(e.target.value);
                    }}
                  />
                  <Label className="mr-sm-2">Telefono</Label>
                  <Input
                    className="col-sm-12"
                    type="number"
                    value={telefonoAgregar}
                    required
                    onChange={(e) => {
                      setTelefonoAgregar(e.target.value);
                    }}
                  />
                  <Label className="mr-sm-2">Tipo</Label>
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={tipoAgregar}
                    required
                    onChange={(e) => {
                      setTipoAgregar(e.target.value);
                    }}
                  >
                    <option value="Admin">Admin</option>
                  </Input>
                </ModalBody>
                <ModalFooter>
                  <Button color="success" onClick={crearTelefono}>
                    Guardar
                  </Button>
                </ModalFooter>
              </Modal>


              {/* Links */}
              {/* <Modal size="sm" isOpen={modalEditLinks} toggle={toggleEditLinks}>
                <ModalHeader toggle={toggleEditLinks}>Editar Link</ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Nombre</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={nameEditLinks}
                    required
                    onChange={(e) => {
                      setNameEditLinks(e.target.value);
                    }}
                  />
                  <Label className="mr-sm-2">Link</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={linkEdit}
                    required
                    onChange={(e) => {
                      setLinkEdit(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="success"onClick={editLink}>
                    Guardar
                  </Button>
                </ModalFooter>
              </Modal>

              <Modal size="sm" isOpen={modalAgregarLinks} toggle={toggleAgregarLinks}>
                <ModalHeader toggle={toggleAgregarLinks}>
                  Agregar Link
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Nombre</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={nameAgregarLinks}
                    required
                    onChange={(e) => {
                      setNameAgregarLinks(e.target.value);
                    }}
                  />
                  <Label className="mr-sm-2">Link</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={linkAgregar}
                    required
                    onChange={(e) => {
                      setLinkAgregar(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="success"  onClick={crearLink}>
                    Guardar
                  </Button>
                </ModalFooter>
              </Modal> */}
            </div>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default WhatsApp;
